import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'src/app/constants';
import { IToken } from 'src/app/interfaces/token/IToken';
import { NovoSuprimentoFormProvider } from 'src/app/providers';
import { AuthenticationService } from 'src/app/services';
import { Environment } from 'src/app/types';
import { aoMenosUmPreenchidoValidator } from 'src/app/validators';

@Component({
  selector: 'app-novo-suprimento',
  templateUrl: './novo-suprimento.component.html',
  styleUrls: ['./novo-suprimento.component.scss'],
  providers: [
    {
      provide: NovoSuprimentoFormProvider,
      useExisting: NovoSuprimentoComponent
    }
  ]
})
export class NovoSuprimentoComponent
  extends NovoSuprimentoFormProvider
  implements OnInit, OnDestroy
{
  private subscription$ = new Subscription();
  private token: IToken;
  private suprimentoForm: FormGroup;
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder
  ) {
    super();
  }
  getForm(): FormGroup {
    return this.suprimentoForm;
  }

  limparForm() {
    this.suprimentoForm.patchValue({
      equipamento: {},
      primeiroPasso: {
        empresa: this.environment.company,
        idUsuario: this.token.id,
        numserie: '',
        codContrato: '',
        contcolor: 0,
        contpb: 0,
        obs: ''
      },
      segundoPasso: {
        cep: '',
        logradouro: '',
        numero: '',
        cidade: '',
        estado: '',
        bairro: '',
        complemento: '',
        usarEnderecoEquipamento: false
      },
      terceiroPasso: {
        email: '',
        telefone: '',
        telefoneAlternativo: '',
        celular: '',
        nome: ''
      }
    });
  }

  ngOnInit(): void {
    this.token = this.authenticationService.obterToken();

    this.suprimentoForm = this.fb.group({
      equipamento: [{}, []],
      primeiroPasso: this.fb.group(
        {
          empresa: [this.environment.company, Validators.required],
          idUsuario: [this.token.id, Validators.required],
          numserie: ['', Validators.required],
          codContrato: ['', Validators.required],
          contcolor: [0, Validators.required],
          contpb: [0, Validators.required],
          obs: ['', [Validators.required, Validators.maxLength(5000)]]
        },
        { validators: [aoMenosUmPreenchidoValidator('contcolor', 'contpb')] }
      ),
      segundoPasso: this.fb.group({
        cep: ['', [Validators.required, Validators.maxLength(9)]],
        logradouro: ['', Validators.required],
        numero: ['', [Validators.required, Validators.pattern(/\d/g)]],
        cidade: ['', Validators.required],
        estado: ['', [Validators.required]],
        bairro: ['', [Validators.required]],
        complemento: ['', []],
        usarEnderecoEquipamento: [false, []]
      }),
      terceiroPasso: this.fb.group(
        {
          email: ['', Validators.required, Validators.maxLength(200)],
          telefone: ['', []],
          telefoneAlternativo: ['', []],
          celular: ['', []],
          nome: ['', Validators.required]
        },
        {
          validators: [
            aoMenosUmPreenchidoValidator(
              'telefone',
              'telefoneAlternativo',
              'celular'
            )
          ]
        }
      )
    });

    this.subscription$.add(
      this.suprimentoForm.get('equipamento')?.valueChanges.subscribe({
        next: ({ numSerie, codigoContr }) => {
          this.suprimentoForm.patchValue({
            primeiroPasso: {
              numserie: numSerie,
              codContrato: codigoContr
            }
          });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
